import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Statistic } from 'semantic-ui-react';
import i18next from 'i18next';

import AreaAdditionForm from '../../area-addition-form/AreaAdditionForm';

import './AdditionPane.scss';

class AdditionPane extends Component {

    constructor(props) {
        super(props);

        this.isEligbleForSubmition = this.isEligbleForSubmition.bind(this);
    }

    isEligbleForSubmition() {
        return this.props.numberOfDraftedDeliveryAreas() > 0;
    }

    render() {
        const { numberOfDraftedDeliveryAreas, addNewDeliveryAreas } = this.props;

        return (
            <Container>
                <AreaAdditionForm
                    addNewDeliveryAreas={addNewDeliveryAreas}
                    isEligbleForSubmition={this.isEligbleForSubmition}
                    addToPool={true}
                   
                />
                <Statistic color='blue' size='small' horizontal>
                    <Statistic.Value>{numberOfDraftedDeliveryAreas()}</Statistic.Value>
                    <Statistic.Label>{i18next.t('newDeliveryAreas')}</Statistic.Label>
                </Statistic>
            </Container>
        );
    }
}

AdditionPane.propTypes = {
    addNewDeliveryAreas: PropTypes.func,
    numberOfDraftedDeliveryAreas: PropTypes.func,
    
};

export default AdditionPane;
